__turbopack_context__.v({
  "main": "AssuredHelpDesk-module-scss-module__dMIznq__main",
  "responsive": "AssuredHelpDesk-module-scss-module__dMIznq__responsive",
});
